import React from 'react';
import { Link } from 'react-router-dom';
import { useGetMeQuery } from '@@/services/user';
import { translateRole } from '@@/constants/user';
import AuthenticatedImage from '@@/components/AuthenticatedImage';

const Footer: React.FC = () => {
  const { data: me } = useGetMeQuery();

  return (
    <Link
      className="relative flex flex-row items-center cursor-pointer h-20 w-full pl-4 font-main"
      to="/me"
    >
      {me?.photoDocumentId ? (
        <AuthenticatedImage
          documentId={me?.photoDocumentId}
          placeholder="/user-profile-placeholder.jpg"
          alt={`${me?.firstName} ${me?.lastName}`}
          className="w-6 h-6 sm:w-10 sm:h-10 bg-white font-main rounded-full"
        />
      ) : (
        <div className="w-10 h-10 font-main rounded-full bg-slate-100 border border-slate-200 flex items-center justify-center">
          <span className="text-sky-600 font-semibold">
            {me?.firstName?.slice(0, 1)}
            {me?.lastName?.slice(0, 1)}
          </span>
        </div>
      )}

      <div className="pl-1 flex flex-col w-[130px] overflow-scroll">
        <p className="text-sm text-slate-700 truncate">
          <span className="truncate">{me?.firstName}</span>
          <span className="font-semibold pl-1 truncate">{me?.lastName}</span>
        </p>
        <p className="text-xs text-slate-500">{translateRole(me?.role)}</p>
      </div>
    </Link>
  );
};

export default Footer;
